import logo from './logo.svg';
import './App.css';
import LoginPage from './LoginPage/LoginPage';

function App() {
  return (
    <LoginPage/>
  );
}

export default App;
